import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { MyUtils } from "../../../../services/my-utils.service";
import { TextCol } from "../../models/columns/text-col";
import { ICellComponent } from "../../models/i-cell-component";

@Component({
  selector: "app-text-cell",
  templateUrl: "./text-cell.component.html",
  styleUrls: ["./text-cell.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextCellComponent<T extends object>
  implements OnInit, ICellComponent<T>
{
  datePipeFormat?: string;

  data!: string | number | Date;

  constructor(public utils: MyUtils) {}

  ngOnInit(): void {}

  setComponentData(el: T, colConfig: TextCol<T>) {
    this.data = colConfig.getElementData(el);
    this.datePipeFormat = colConfig.datePipeFormat;
    if (colConfig.isTranslate && this.data) {
      this.data = this.utils.traslatei18n(this.data.toString());
    }
  }

  useRomeDatePipe(): boolean {
    if (!this.datePipeFormat) {
      return false;
    }

    return /(HH|mm|ss)/.test(this.datePipeFormat);
  }

  truncate(data: string | number | Date){
    if (typeof(data) === 'string' && data.length > 30){
      data = data.substring(0, 30) + '...';
    }
    return data;
  }


  truncateWords(data: string | number | Date){
    const maxSize=21
    if (typeof(data) === 'string' && data.length > maxSize){
      const words = data.split(' ');
      
      if (words[0].length > maxSize || words[1].length>maxSize) {
        data = data.substring(0, maxSize) + '...';
      }
      
    }
    return data;
  }

  isString(data:any) {
    return data && typeof(data) ==='string' && data.length > 30;
  }
}
